/* ActionableIcon.js */

"use strict";
const BaseIcon = require("../base/BaseIcon");

class ActionableIcon extends BaseIcon {
    createdCallback() {
        super.createdCallback(arguments);
        this._disabled = false;
        this._active = false;
        this._valid = true;
        this.addEventListener("click", (evt) => {
            if (this._disabled) {
                evt.stopImmediatePropagation();
            }
        });
    }

    attachedCallback() {
        super.attachedCallback(arguments);
        if (this.hasAttribute("data-disabled")) {
            this.setDisabled(true);
        }
    }

    // attributeChangedCallback(/*attrName, oldVal, newVal*/){
    //     super.attributeChangedCallback(arguments);
    // }

    // detachedCallback(){
    //     super.detachedCallback(arguments);
    // }

    ///////////////////////////////////////
    // DISABLED - BEGIN
    ///////////////////////////////////////
    enable() {
        this.setDisabled(false);
    }

    disable() {
        this.setDisabled(true);
    }

    get disabled() {
        return this._disabled;
    }

    set disabled(bool) {
        this.setDisabled(bool);
    }

    setDisabled(bool) {
        if (bool) {
            this._disabled = true;
            this.classList.add("disabled");
            // this.addEventListener("click",this._onClick);
        } else {
            this._disabled = false;
            this.classList.remove("disabled");
        }
    }
    ///////////////////////////////////////
    // DISABLED - END
    ///////////////////////////////////////

    ///////////////////////////////////////
    // ACTIVE - BEGIN
    ///////////////////////////////////////
    isActive() {
        return this.getActive();
    }
    get active() {
        return this.getActive();
    }

    set active(bool) {
        this.setActive(bool);
    }

    getActive() {
        return this._active;
    }

    setActive(bool) {
        if (bool) {
            this._active = true;
            this.classList.add("active");
        } else {
            this._active = false;
            this.classList.remove("active");
        }
    }
    ///////////////////////////////////////
    // ACTIVE - END
    ///////////////////////////////////////
}

let icon,
    customElementRegistry = window.customElements;

if (customElementRegistry) {
    icon = customElementRegistry.get("actionable-icon-gl");
    if (!icon) {
        customElementRegistry.define("actionable-icon-gl", ActionableIcon);
        icon = customElementRegistry.get("actionable-icon-gl");
    }
} else if (document.registerElement) {
    icon = document.registerElement("actionable-icon-gl", ActionableIcon);
} else {
    icon = ActionableIcon;
}

module.exports = icon;
